import React from 'react'
import { Row as IRow, TableRowProps } from 'react-table'
import { useTableContext } from '../context'

const Row: React.FC<TableRowProps & { row: IRow }> = ({ row, ...props }) => {
    return (
        <tr {...props}>
            {row.cells.map(cell => {
                const style = { 
                    maxWidth: cell.column.maxWidth,
                    width: cell.column.width,
                    minWidth: cell.column.minWidth
                }

                return (
                    <td {...cell.getCellProps()} style={style}>
                        {cell.render('Cell')}
                    </td>
                )
            })}
        </tr>
    )
}

export default React.memo(Row)

const getEmptyContent = (data?: object[], globalFilter?: string) => {
    if (!data)
        return "Loading..."
    
    if (globalFilter)
        return "We can't find rows you're looking for"
    
    return "The table doesn't have any rows"
}

export const EmptyRow: React.FC = () => {
    const { visibleColumns: columns, data, state } = useTableContext()
    const content = getEmptyContent(data, state?.globalFilter)

    if (!columns) throw "Error: element `EmptyRow` was rendered outside the table context provider."

    return (
        <tr>
            <td colSpan={columns.length}>{content}</td>
        </tr>
    )
}
